import { useEffect, useState } from "react";
import MyTable from "../common/mytable";
import addicon from '../images/additem.png';
import img1 from '../images/facility.png';
import axios from "axios";
import loadIcon from '../images/loader2.webp';
import excel from '../images/excelicon.png';
import resourcesicon from "../images/resourceicon.png";
import { exportToExcel } from "../common/mylib";

const Facilities=()=>{           
    const [show,setShow]=useState(false);
    const [showresources,setShowResources]=useState(false);
    const [progress,setProgress]=useState(false);
    const [msg,setMsg]=useState("");
    const [facilitydata,setFacilityData]=useState([]);
    const [freeresources,setFreeResources]=useState([]);
    const [usedresources,setUsedResources]=useState([]);

    const [formData,setFormData]=useState({id:"",facilityname:"",address:"",state:"",city:"",pincode:"",mobile:""});
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [
        { name: "ID", key: "id", sortable: true },
        { name: "Facility", key: "facilityname", sortable: true },
        { name: "Mobile", key: "mobile", sortable: false},      
        { name: "Address", key: "address", sortable: false },
        { name: "State", key: "state", sortable: true },
        { name: "City", key: "city", sortable: true },
        { name: "Pincode", key: "pincode", sortable: false },                
    ];
    function addFacility(event)
    {
        setFormData({id:"",facilityname:"",address:"",state:"",city:"",pincode:"",mobile:""});
        setShow(true);
    }
    async function saveData(event)
    {
        
        setMsg("");
        if(window.confirm('Are you sure?'))
        {
            
            setProgress(true);
            let url="/api/Facilities/Create";            
            if(formData.id!="") url="/api/Facilities/Update";
            let datajson=JSON.stringify(formData);           
                await apiClient.post(url,datajson).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadFacilities();
                        alert("Data Saved Successfully");
                        setFormData({id:"",facilityname:"",address:"",state:"",city:"",pincode:"",mobile:""});
                        setShow(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                });  
            setProgress(false); 
        }
    }
    async function loadFacilities()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Facilities/GetAll").then(res=>
        {
            if(res.status==200)
            {
                setFacilityData(res.data.data);
            }
        });       
        setProgress(false);
    }
    async function loadResources(facilityid)
    {
        //console.log("Loading Resources for Facility ID:", facilityid);
        setProgress(true);        
        await apiClient.post(process.env.REACT_APP_APIURL+"/api/Resource/GetFreeResourcesInFacility/"+facilityid).then(res=>
        {
            if(res.status==200)
            {
                setFreeResources(res.data.data);
            }
        });
        await apiClient.post(process.env.REACT_APP_APIURL+"/api/Resource/GetUsedResourcesInFacility/"+facilityid).then(res=>
        {
            if(res.status==200)
            {
                setUsedResources(res.data.data);
            }
        });        
        setProgress(false);
        setShowResources(true);
    }
    function formValueChanged(event)
    {
        if(event.target.id=="fid") setFormData({...formData,id:event.target.value});
        if(event.target.id=="fname") setFormData({...formData,facilityname:event.target.value});
        if(event.target.id=="faddress") setFormData({...formData,address:event.target.value});
        if(event.target.id=="fstate") setFormData({...formData,state:event.target.value});
        if(event.target.id=="fcity") setFormData({...formData,city:event.target.value});
        if(event.target.id=="fpincode") setFormData({...formData,pincode:event.target.value});
        if(event.target.id=="fmobile") setFormData({...formData,mobile:event.target.value});
    }
    async function deleteFacility(id)
    {
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
            await apiClient.post(process.env.REACT_APP_APIURL+"/api/Facilities/Delete/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadFacilities();
                }
            });
        }
    }    
    function editFacility(id)
    {
        apiClient.get(process.env.REACT_APP_APIURL+"/api/Facilities/GetById/"+id).then(res=>
        {
            if(res.status==200 && res.data.status=="OK")
            {
                setFormData(res.data.data);                
                setShow(true);
            }
        });
    }    
    
    useEffect(()=>{
        loadFacilities();
    },[]);
    return(
        <div>            
            <div className="p-2 text-end">
                <div className="text-end">
                    <img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addFacility} />
                    <img onClick={()=>{exportToExcel('tblexport','Facilities')}} src={excel} style={{width:'30px',marginLeft:'10px',cursor:'pointer'}} />
                </div>
            </div>
            <MyTable id="tblexport" tbldata={facilitydata} heading="Facilities Details" columns={columns} isView={false} isEdit={true} isDelete={true} editFunction={editFacility} isShowResources={true} showResources={loadResources} deleteFunction={deleteFacility} />
                {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Facility</div>
                                    <input type="text" id="fid" onChange={formValueChanged} value={formData.id} className="form-control mt-2 d-none"/>
                                    <input type="text" id="fname" onChange={formValueChanged} value={formData.facilityname} className="form-control mt-2" placeholder="Facility Name" />
                                    <input type="number" id="fmobile" onChange={formValueChanged} value={formData.mobile} className="form-control mt-2" placeholder="Mobile No" />
                                    <textarea id="faddress" onChange={formValueChanged} value={formData.address} className="form-control mt-2" placeholder="Address" ></textarea>
                                    <input type="text" id="fstate" onChange={formValueChanged} value={formData.state} className="form-control mt-2" placeholder="State" />
                                    <input type="text" id="fcity" onChange={formValueChanged} value={formData.city} className="form-control mt-2" placeholder="City" />
                                    <input type="number" id="fpincode" onChange={formValueChanged} value={formData.pincode} className="form-control mt-2" placeholder="Pin Code" />
                                    <input type="button" className="btn btn-danger mt-2" onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
                {showresources && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-top modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAFFDE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShowResources(false)}></button></div>
                                    <h4>Free Resources</h4>
                                    <div style={{overflowY:'auto',maxHeight:'350px',fontSize:'12px'}}>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Abbr</th>
                                                    <th>Name</th>
                                                    <th>Description</th>
                                                    <th>Resource Type</th>                                                    
                                                </tr>   
                                            </thead>
                                            <tbody>
                                                {freeresources.map((res,i)=>(
                                                    <tr key={i}>
                                                        <td>{i+1}</td>
                                                        <td>{res.abbr}</td>
                                                        <td>{res.name}</td>
                                                        <td>{res.description}</td>
                                                        <td>{res.rtype}</td>                                                        
                                                    </tr>
                                                ))} 
                                            </tbody>
                                        </table>
                                    </div>
                                    <h4>Used Resources</h4>
                                    <div style={{overflowY:'auto',maxHeight:'350px',fontSize:'12px'}}>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Abbr</th>
                                                    <th>Name</th>
                                                    <th>Description</th>
                                                    <th>Resource Type</th>                                                    
                                                </tr>   
                                            </thead>
                                            <tbody>
                                                {usedresources.map((res,i)=>(
                                                    <tr key={i}>
                                                        <td>{i+1}</td>
                                                        <td>{res.abbr}</td>
                                                        <td>{res.name}</td>
                                                        <td>{res.description}</td>
                                                        <td>{res.rtype}</td>                                                        
                                                    </tr>
                                                ))} 
                                            </tbody>
                                        </table>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
        </div>
    );
}
export default Facilities;